import { Row, Col } from "antd";
import { useSelector } from "react-redux";
import {
  formatDateTimeString,
  formatValueToArray,
} from "@/utils/helperFunctions";
import ImageHolder from "./ImageHolder";
import VideoHolder from "./VideoHolder";
import UniversalValidator from "../UniversalValidator";
import { Section, Title, StyledValueContainer, ApprovedInfo } from "./styles";

const NoRewardAnswers = ({
  form,
  enrollment = {},
  answers,
  isFraudCheck,
  isPreRecruit,
  onChangeUniversal,
  onSaveMediaMark,
  getSavedMediaMark,
}) => {
  const { validator, validatedAt } = enrollment;

  return (
    <Section>
      <Title>Other media for this enrollment</Title>

      <Row gutter={5}>
        <Col span={8}>
          <UniversalValidator
            form={form}
            isFraudCheck={isFraudCheck}
            isPreRecruit={isPreRecruit}
            onChangeUniversal={onChangeUniversal}
          />

          {validator && (
            <ApprovedInfo>
              <span>Approved by:</span>
              <span>{validator}</span>
            </ApprovedInfo>
          )}

          {validatedAt && (
            <ApprovedInfo>
              <span>Approved at:</span>
              <span>{formatDateTimeString(validatedAt)}</span>
            </ApprovedInfo>
          )}
        </Col>

        <Col span={16}>
          <StyledValueContainer>
            {answers?.map((answer) => {
              const { value, typeOfQuestion } = answer;

              const formatedValue = formatValueToArray(value);
              return formatedValue?.map((url, index) => {
                const isUrl = typeof url === "string";
                const saved = getSavedMediaMark?.(answer._id, url);
                const mediaProps = {
                  answerId: answer._id,
                  questionId: answer.question_id,
                  enrollmentId: answer.enrollment_id,
                  productId: answer.product_id,
                  typeOfQuestion,
                  onSaveMediaMark,
                  clientSubmission: !!saved?.clientSubmission,
                  promotionalPackage: !!saved?.promotionalPackage,
                  promotionalComment: saved?.promotionalComment || "",
                };

                if (isUrl && typeOfQuestion === "upload-picture") {
                  return <ImageHolder key={index} url={url} {...mediaProps} />;
                }

                if (isUrl && typeOfQuestion === "upload-video") {
                  return <VideoHolder key={index} url={url} {...mediaProps} />;
                }

                return null;
              });
            })}
          </StyledValueContainer>
        </Col>
      </Row>
    </Section>
  );
};

export default NoRewardAnswers;
